export default "__VITE_ASSET__Cu7DGdGw__";